<template>
  <v-row>
    <v-col cols="12" class="d-flex align-center">
      <h2>{{ $t('withdraw.head_list3') }}</h2>
      <v-divider class="mx-3" vertical />
      <v-breadcrumbs :items="breadcrumbsItems" divider=">>" />
    </v-col>
    <v-divider class="mx-3" vertical />
    <v-col cols="12">
      <v-card>
        <v-card-title>{{ $t('withdraw.head_list4') }} </v-card-title>
        <v-divider class="mx-3" />
        <v-card-actions>
          <v-row>
            <v-col cols="12" xs="12" md="6" lg="4">
              <v-text-field v-model="datas.member.phone" label="Username" outlined dense readonly />
            </v-col>
            <v-col cols="12" xs="12" md="6" lg="4">
              <v-text-field label="New Password" outlined dense type="password" readonly />
            </v-col>
            <v-col cols="12" xs="12" md="6" lg="4">
              <v-text-field v-model="datas.member.line" label="Line" outlined dense readonly />
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-actions>
          <v-row>
            <v-col cols="12" xs="12" md="6" lg="4">
              <v-text-field v-model="datas.member.member_game" label="Username (member)" outlined dense readonly />
            </v-col>
            <v-col cols="12" xs="12" md="6" lg="4">
              <v-text-field label="Password (member)" outlined dense type="password" readonly />
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title> {{ $t('withdraw.head_list5') }} </v-card-title>
        <v-divider class="mx-3" />
        <v-card-actions>
          <v-row>
            <!-- Alert บัญชีถอนเพิ่มเติม -->
            <v-col cols="12" v-if="datas.is_additional_withdraw">
              <v-alert type="warning" dense class="mb-0">
                บัญชีถอนเพิ่มเติม #{{ datas.additional_withdraw_index }}
              </v-alert>
            </v-col>
            <v-col cols="12" xs="12" md="6" lg="4">
              <v-select
                :value="datas.is_additional_withdraw ? (datas.additional_withdraw_bank_code || datas.additional_withdraw_bank) : datas.member.bank"
                :label="$t('bank')" item-text="label" :items="bankItems" outlined dense readonly />
            </v-col>
            <v-col cols="12" xs="12" md="6" lg="4">
              <v-text-field
                :value="datas.is_additional_withdraw ? datas.additional_withdraw_bank_number : datas.member.bank_account"
                :label="$t('account_number')" outlined dense readonly />
            </v-col>
            <v-col cols="12" xs="12" md="6" lg="4">
              <v-text-field
                :value="datas.is_additional_withdraw ? datas.additional_withdraw_bank_name : datas.member.name"
                :label="$t('account_name')" outlined dense readonly />
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-actions>
          <v-row>
            <v-col cols="12" xs="12" md="6" lg="4">
              <v-text-field v-model="datas.amount" :label="$t('withdraw.amount')" outlined dense readonly />
            </v-col>
            <v-col cols="12" xs="12" md="6" lg="4">
              <v-text-field v-model="datas.created_at" :label="$t('withdraw.header4')" outlined dense readonly />
            </v-col>
          </v-row>
        </v-card-actions>
        <v-divider class="mx-3" v-if="this.canCreate"/>
        <v-card-title v-if="this.canCreate"> {{$t('withdraw.edit_status') }}</v-card-title>
        <v-divider class="mx-3"  v-if="this.canCreate"/>
        <div style="margin-top: 10px;"  v-if="this.canCreate"/>
        <v-col cols="12" xs="12" md="6" lg="4"  v-if="this.canCreate">
          <v-row>
            <div style="margin-right: 20px;margin-top: 10px;"/>
          <v-select v-model="statusSelect" :label="$t('withdraw.please_select')" item-text="label" :items="statusItems" item-value="value" outlined
                dense  v-if="this.canCreate"/><div style="margin-right: 10px;"/>
          <v-btn color="warning" @click="updateStatus"  v-if="this.canCreate">
            <span class="px-3">{{ $t('edit') }}</span>
          </v-btn>
          </v-row>
        </v-col>
        <v-divider class="mx-3"  v-if="this.canCreate" />
        <v-card-actions>
          <v-spacer />
          <v-btn color="warning" @click="$router.push({ name: 'withdraw' })">
            <v-icon>mdi-arrow-left</v-icon>
            <span class="px-3">{{ $t('back') }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import store from '@/store'
export default {
  data() {
    return {
      breadcrumbsItems: [
        {
          text: this.$t('withdraw.head_list2'),
          disabled: false,
          href: '/withdraw',
        },
        {
          text: this.$t('withdraw.check_head'),
          disabled: true,
          href: '',
        },
      ],
      userInfo: {
        name: null,
        role: null,
      },
      bankSelect:"ไม่แก้ไข",
      bankItems: [],
      underUse: [],
      statusSelect:"เลือกแก้ไข",
      statusItems: [{ label: this.$t('withdraw.status1'), value: 'wait' },{ label: this.$t('withdraw.status2'), value: 'success_auto' },{ label: this.$t('withdraw.status3'), value: 'success_manual' },{ label: this.$t('withdraw.status4'), value: 'cancel' }],
      id: this.$route.params.id,
      datas: {},
    }
  },
  async created() {
    this.addLogPage()
    this.getPermissionsEdit()
    this.bankItems = await this.$store.dispatch('getTypeBankData')
    this.data = await this.$store.dispatch('getWithdraw', {
      id: this.id,
      page: 1,
      rows: 1,
    })
    this.datas = this.data.data[0]
    this.datas.created_at = moment(this.datas.created_at).format('YY-MM-DD HH:mm')
  },
  async mounted() {
    let userInfo = this.$store.getters.getuserInfo
    this.userInfo.name = userInfo.name
    this.userInfo.role = userInfo.role
  },
  methods: {
    async addLogPage() {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(res =>
          data = {
            ip: res.data.ip,
            name: 'ถอนเงิน',
            url: window.location.href,
            detail: 'ระบบจัดการถอนเงิน',
            admin: userSystem.name ? userSystem.name : '' ? userSystem.name : '',
          }
        )
        await this.$store.dispatch('addLogPage', data)
      } catch (e) {
        // if (!e.message.includes('Unexpected token') || !e?.includes('Unexpected token') || !e.message.includes('Unexpected identifier')) {
        //   this.$swal.fire({
        //     icon: 'error',
        //     title: e.message,
        //   })
        // }
      }
    },
    async getPermissionsEdit() {
      let psSystem = store.getters.getPermissionsEdit
      let chkEdit = psSystem.filter(el => el === 'editWithdraw')
      if (chkEdit && chkEdit?.length > 0) {
        this.canCreate = true
      }
    },
    async updateStatus() {
      if(this.statusSelect!=="เลือกแก้ไข"){
        this.$swal
        .fire({
          icon: 'warning',
          title: this.$t("alert"),
          text: `${this.$t("withdraw.edit_confirm")}`,
          showCancelButton: true,
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
        })
        .then(async result => {
          /* Read more about isConfirmed, isDenied below */
          this.loading = true
          let params = {
            id: this.id,
            status: this.statusSelect,
          }
          if (result.isConfirmed) {
            await this.$store.dispatch('updateWithdrawStatus', params)
            this.$swal.fire(this.$t("withdraw.edit_complete"), '', 'success')
            this.loading = false
          }
        })
      }
    },
  }
}
</script>
